// @flow
import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import type { DispatchType } from "../../global/types/redux";
import type { ErrorsType } from "../types/UserFormType";
import { ErrosDisplay, setErrorMsg, checkEmail, } from "../containers/ErrosDisplay";
import { SingleTextField, CancelButton, SubmitButton } from "imagus-components";
import UserAuth from "../../global/containers/UserAuth";
import RedirectoIndex from "./RedirectoIndex";
import { userForgotPassword } from "../actions/profileActions";
import BlueLogoImage from "../../../images/VixVizion.svg";
import history from "../../../history";

import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import EmailIcon from "@material-ui/icons/Email";

const DEBOUNCETIME = 500;

type ForgotStatesType = {
  errors: ErrorsType,
  username: string,
  loading: boolean
};

class ForgotForm extends Component<*, ForgotStatesType> {
  timeout: number;
  constructor(props) {
    super(props);
    this.submit = this.submit.bind(this);
    this.state = {
      errors: {},
      loading: false,
      username: ""
    };
  }

  handleChange = (e: Event & { currentTarget: HTMLInputElement }): * => {
    const name = e.currentTarget.name;
    const value = e.currentTarget.value;
    this.setState((state: ForgotStatesType) => ({
      [name]: value
    }));

    clearTimeout(this.timeout);
    this.timeout = setTimeout(function (val: string) {
      this.setState({ errors: checkEmail(this.state.errors, val) });
    }.bind(this, value), DEBOUNCETIME);
  }

  submit = async (e: Event): * => {
    e.preventDefault();
    e.stopPropagation();
    this.setState((): * => ({ "loading": true }));

    if (Object.keys(this.state.errors).length === 0) {
      const username = encodeURI(this.state.username.trim());
      this.props.actions.userForgotPassword(
        username,
        (): * => {
          history.push(`/forgot2/${username}`);
        },
        (errors: ErrorsType): * => {
          this.setState({
            errors: errors
          });
        }
      );
    }

    this.setState((): * => ({ "loading": false }));
  }

  render(): React$Element<*> {
    const { errors, loading } = this.state;
    return (
      <div className="wrapper">
        <img src={BlueLogoImage} className="form-logo" style={{ float: "left" }} />
        <div style={{ clear: "both" }}></div>

        <div className="form-text">
          <Typography variant="h5" className="green-title" style={{ marginBottom: "30px" }}>Forgot Your Password?</Typography>
          <Typography variant="subtitle1" className="green-title" style={{ marginBottom: "30px" }}>If you forgot your password, please enter your email address and we'll send you and email to reset your password.</Typography>
        </div>
        <form onSubmit={(!loading && this.submit) || undefined}>
          <Grid container spacing={8}>
            <Grid item xs={1} className="icon-block">
              <EmailIcon className="green-icon medium-icon" />
            </Grid>
            <Grid item xs={11}>
              <SingleTextField
                isRequired={true}
                label="Email Address"
                name="username"
                value={this.state.username}
                onChange={this.handleChange}
                inpuType="text"
                isInvalid={errors.username !== undefined}
              />
            </Grid>
            <Grid item xs={12}>
              <ErrosDisplay errors={errors} form="reset password" />
            </Grid>
            <Grid item xs={12}>
              <div className="form-right-btn-block">
                <CancelButton onClick={() => history.push("/login")} />
                <SubmitButton
                  loading={loading}
                  title="Send Reset Email"
                  disabled={Object.keys(errors).length > 0}
                />
              </div>
            </Grid>
          </Grid>
        </form>
      </div>
    );
  }
}

const mapDispatchToProps = (dispatch: DispatchType): DispatchType => ({
  actions: bindActionCreators({ userForgotPassword }, dispatch)
});

const ReduxForgotForm = connect(null, mapDispatchToProps)(ForgotForm);

class ForgotPage extends Component<*> {
  render(): React$Element<*> {
    return (
      <UserAuth principal='user' unAuthChildren={<ReduxForgotForm />}>
        <RedirectoIndex />
      </UserAuth>
    );
  }
}

export default ForgotPage;
